import React from 'react'
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import './default.css'

const HeaderForChat = (props) => {
    const navigate = useNavigate()
    const goingOnBackPage = () => {
        navigate(props.navigate)
    }

    return (
        <div className='h-16 p-3 flex justify-between items-center shadow-lg'>
            <div onClick={goingOnBackPage} className='cursor-pointer h-[36px] w-[36px] bg-primary text-white rounded-[100%] items-center flex justify-center'><IoArrowBack size={20} /></div>
            <div className='slide-in text-[16px] font-semibold text-primary'>{props.title}</div>
        </div>
    )
}

export default HeaderForChat
